var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "tit": "자주묻는질문",
      "sc": "자주묻는질문 서브텍스트가 들어갑니다.",
      "bg": "/images/sub/visual/sv-question.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('faq-list')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }